"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestSpinner = void 0;
var React = require("react");
// import './style.scss'
var raf = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame;
var speed = 10;
var oneStep = speed * (Math.PI / 180);
var fps = 60;
var fpsInterval = 1000 / fps;
var half = Math.PI;
var full = 2 * Math.PI;
var initColor = { r: 0, g: 170, b: 247 };
var scale = 0.9;
var failureOffset = 0.23;
var RequestSpinner = /** @class */ (function (_super) {
    __extends(RequestSpinner, _super);
    function RequestSpinner(props) {
        var _this = _super.call(this, props) || this;
        // animation start
        _this.then = new Date().getTime();
        // Circle position
        _this.sA = 0;
        _this.eA = 0;
        // Circle color
        _this.color = __assign({}, initColor);
        // Mark state
        _this.mark = 0;
        _this.state = {
            current: 'STANDBY'
        };
        return _this;
    }
    RequestSpinner.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isLoading !== nextProps.isLoading && nextProps.isLoading) {
            this.setState({ current: 'STANDBY' });
            this.sA = 0;
            this.eA = 0;
            this.color = __assign({}, initColor);
        }
    };
    RequestSpinner.prototype.componentWillUnmount = function () {
        this.e.removeEventListener('onresize', this.setSize.bind(this));
    };
    RequestSpinner.prototype.drawArc = function (s, b) {
        this.c.beginPath();
        this.c.arc(0, 0, this.r, s, b, false);
        this.c.strokeStyle = "rgb(".concat(this.color.r, ", ").concat(this.color.g, ", ").concat(this.color.b, ")");
        this.c.lineWidth = this.strength;
        this.c.stroke();
    };
    RequestSpinner.prototype.drawCheckMark = function () {
        if (this.state.current === 'SUCCESS') {
            var hSize = this.strength / 3;
            this.c.beginPath();
            var p1x = -(this.size * 0.27);
            var p1y = -(this.size * 0);
            var p2x = -(this.size * 0.09 - hSize);
            var p2y = -(this.size * 0.18 + hSize);
            this.c.moveTo(p1x, p1y);
            this.c.lineTo(p2x, p2y);
            if (this.mark < 0.3) {
                var color = this.c.createLinearGradient(p1x, p1y, p2x, p2y);
                var mark = this.mark / 0.3;
                color.addColorStop(0, 'rgba(0, 175, 02, 1)');
                mark > 0.01 && color.addColorStop(mark - 0.01, 'rgba(0, 175, 02, 1)');
                color.addColorStop(mark, 'rgba(0, 175, 02, 0)');
                color.addColorStop(1, 'rgba(0, 175, 02, 0)');
                this.c.strokeStyle = color;
            }
            else {
                this.c.strokeStyle = 'rgba(0, 175, 02, 1)';
            }
            this.c.lineWidth = this.strength;
            this.c.stroke();
            this.c.beginPath();
            var p3x = -(this.size * 0.09 + hSize);
            var p3y = -(this.size * 0.18 + hSize);
            var p4x = this.size * 0.29;
            var p4y = this.size * 0.2;
            this.c.moveTo(p3x, p3y);
            this.c.lineTo(p4x, p4y);
            if (this.mark < 1 && this.mark >= 0.3) {
                var color = this.c.createLinearGradient(p3x, p3y, p4x, p4y);
                var mark = (this.mark - 0.3) / 0.7;
                color.addColorStop(0, 'rgba(0, 175, 02, 1)');
                mark > 0.01 && color.addColorStop(mark - 0.01, 'rgba(0, 175, 02, 1)');
                color.addColorStop(mark, 'rgba(0, 175, 02, 0)');
                color.addColorStop(1, 'rgba(0, 175, 02, 0)');
                this.c.strokeStyle = color;
            }
            else if (this.mark < 0.3) {
                this.c.strokeStyle = 'rgba(0, 175, 02, 0)';
            }
            else {
                this.c.strokeStyle = 'rgba(0, 175, 02, 1)';
            }
            this.c.lineWidth = this.strength;
            this.c.stroke();
        }
    };
    RequestSpinner.prototype.drawFailure = function () {
        if (this.state.current === 'FAILURE') {
            this.c.beginPath();
            var p1x = this.size * failureOffset;
            var p1y = this.size * failureOffset;
            var p2x = -(this.size * failureOffset);
            var p2y = -(this.size * failureOffset);
            this.c.moveTo(p1x, p1y);
            this.c.lineTo(p2x, p2y);
            if (this.mark > 1 && this.mark < 2) {
                var color = this.c.createLinearGradient(p1x, p1y, p2x, p2y);
                var mark = 2 - this.mark;
                color.addColorStop(0, 'rgba(255, 0, 0, 0)');
                color.addColorStop(mark, 'rgba(255, 0, 0, 0)');
                mark < 0.99 && color.addColorStop(mark + 0.01, 'rgba(255, 0, 0, 1)');
                color.addColorStop(1, 'rgba(255, 0, 0, 1)');
                this.c.strokeStyle = color;
            }
            else if (this.mark > 2) {
                this.c.strokeStyle = 'rgba(255, 0, 0, 1)';
            }
            else {
                this.c.strokeStyle = 'rgba(255, 0, 0, 0)';
            }
            this.c.lineWidth = this.strength;
            this.c.stroke();
            // ###################
            this.c.beginPath();
            var p3x = -(this.size * failureOffset);
            var p3y = this.size * failureOffset;
            var p4x = this.size * failureOffset;
            var p4y = -(this.size * failureOffset);
            this.c.moveTo(p3x, p3y);
            this.c.lineTo(p4x, p4y);
            if (this.mark < 1) {
                var color = this.c.createLinearGradient(p3x, p3y, p4x, p4y);
                var mark = this.mark;
                color.addColorStop(0, 'rgba(255, 0, 0, 1)');
                mark > 0.01 && color.addColorStop(mark - 0.01, 'rgba(255, 0, 0, 1)');
                color.addColorStop(mark, 'rgba(255, 0, 0, 0)');
                color.addColorStop(1, 'rgba(255, 0, 0, 0)');
                this.c.strokeStyle = color;
            }
            else {
                this.c.strokeStyle = 'rgba(255, 0, 0, 1)';
            }
            this.c.lineWidth = this.strength;
            this.c.stroke();
        }
    };
    RequestSpinner.prototype.handleStandBy = function () {
        if (this.state.current === 'STANDBY') {
            var d = this.eA - this.sA;
            if (d < half) {
                this.eA += 0.5 * oneStep;
            }
            if (d > half) {
                this.eA = this.sA + half;
            }
            if (d === half) {
                this.setState({ current: 'LOADING' });
            }
        }
    };
    RequestSpinner.prototype.handleLoading = function () {
        var current = this.state.current;
        if (current === 'STANDBY' || current === 'LOADING') {
            this.eA += oneStep;
            this.sA += oneStep;
        }
    };
    RequestSpinner.prototype.handleSuccess = function () {
        if (this.state.current === 'LOADING' &&
            !this.props.isLoading &&
            this.props.success) {
            var d = this.eA - this.sA;
            if (d < full) {
                this.eA += 0.5 * oneStep;
                var g = Math.floor(this.color.g + 175 / 50);
                var b = Math.floor(this.color.b + -253 / 50);
                this.color = {
                    r: 0,
                    g: g > 175 ? 175 : g,
                    b: b < 2 ? 2 : b
                };
            }
            if (d >= full) {
                this.eA = full;
                this.sA = 0;
                this.color = {
                    r: 0,
                    g: 175,
                    b: 2
                };
                this.mark = 0;
                this.setState({ current: 'SUCCESS' });
            }
        }
        else if (this.state.current === 'SUCCESS') {
            if (this.mark < 1) {
                this.mark += 0.06;
            }
        }
    };
    RequestSpinner.prototype.handleFailure = function () {
        if (this.state.current === 'LOADING' &&
            !this.props.isLoading &&
            !this.props.success) {
            var d = this.eA - this.sA;
            if (d < full) {
                this.eA += 0.5 * oneStep;
                var r = Math.floor(this.color.r + 255 / 30);
                var g = Math.floor(this.color.g + -170 / 30);
                var b = Math.floor(this.color.b + -247 / 30);
                this.color = {
                    r: r > 255 ? 255 : r,
                    g: g < 0 ? 0 : g,
                    b: b < 0 ? 0 : b
                };
            }
            if (d >= full) {
                this.eA = full;
                this.sA = 0;
                this.color = {
                    r: 255,
                    g: 0,
                    b: 0
                };
                this.mark = 0;
                this.setState({ current: 'FAILURE' });
            }
        }
        else if (this.state.current === 'FAILURE') {
            this.mark += 0.1;
        }
    };
    RequestSpinner.prototype.draw = function () {
        var _a = this, c = _a.c, w = _a.w, h = _a.h, sA = _a.sA, eA = _a.eA;
        var now = new Date().getTime();
        var dt = now - this.then;
        raf(this.draw.bind(this));
        if (c !== undefined && dt > fpsInterval) {
            this.then = now - dt % fpsInterval;
            this.handleLoading();
            this.handleStandBy();
            this.handleFailure();
            this.handleSuccess();
            c.save();
            c.clearRect(0, 0, w, h);
            c.translate(w / 2, h / 2);
            c.scale(1, -1);
            this.drawArc(sA, eA);
            this.drawFailure();
            this.drawCheckMark();
            c.restore();
        }
    };
    RequestSpinner.prototype.setSize = function () {
        this.w = this.c.canvas.width = this.parent.clientWidth;
        this.h = this.c.canvas.height = this.parent.clientHeight;
        if (this.w < this.h) {
            this.size = this.w;
        }
        else {
            this.size = this.h;
        }
        // Radius
        this.r = this.size / 2 * scale;
        // Path strength
        this.strength = Math.floor(this.size * 0.04);
    };
    RequestSpinner.prototype.init = function (e) {
        if (e) {
            this.e = e;
            this.c = e.getContext('2d');
            this.parent = e.parentElement;
            this.parent.addEventListener('onresize', this.setSize.bind(this));
            this.setSize();
            this.draw();
        }
    };
    RequestSpinner.prototype.render = function () {
        return (React.createElement("div", { className: 'sok-request-spinner' },
            React.createElement("canvas", { ref: this.init.bind(this) })));
    };
    return RequestSpinner;
}(React.Component));
exports.RequestSpinner = RequestSpinner;
//# sourceMappingURL=index.js.map